import { HTMLAttributes } from "react";
import "./title.scss";

interface TitleProps extends HTMLAttributes<HTMLDivElement> {}

const Title = ({ children, className }: TitleProps) => {
  return (
    <section
      className={
        className ? "title-main".concat(" ", className ?? "") : "title-main"
      }
    >
      <h2>{children}</h2>
    </section>
  );
};

export default Title;
